import axios from "@/axios";
import {notification} from "ant-design-vue";

const state = {
  getDataCustomer: [],
  loading: false,
  customerById:[],
  successData:undefined,
  loadingUnActiveAccount:false
};

const actions = {
    async CustomerId({commit},id) {
        try {
            commit('LOADING', true);
            let res = await axios.get('admin/customer/'+id);
            console.log(res.data,'res-collection')
            commit('CUSTOMER_ID', res.data);
        } catch (e) {
            commit('ERROR', e);
            throw e;
        } finally {
            commit('LOADING', false);
        }
    },
    async editCustomer({commit}, payload) {

            try{
                      commit('LOADING', true);
                      await axios({
                          method: 'put',
                          url: 'admin/customer/'+payload.id,
                          data: {id:payload.id,data:payload.data,op:'update'}
                      }).then((res)=>{
                          console.log(res,res.data,'--->res data')
                          commit('SUCCESS_DATA',res.data)
                          commit('EDIT_CUSTOMER', payload);
                          notification.success({
                              message: "پیغام موفقیت آمیز",
                              description: "اطلاعات شما با موفقیت ویرایش شد.",
                              duration: 1,
                          })
                      })
            }
            catch (e) {
                commit('ERROR', e);
            }
            finally {
                commit('LOADING', false);
            }
    },
    async Authentication({commit}, payload) {
            try{
              commit('LOADING', true);
              await axios.put('admin/customer/'+payload.id,{data:payload,op:'sts'})
            }
            catch (e) {
                commit('ERROR', e);
            }
            finally {
                commit('LOADING', false);
            }
    },
    async reject({commit}, payload) {
            try{
                await axios.put('admin/customer/'+payload.id,{data:payload,op:'sts'})
            }
            catch (e) {
                commit('ERROR', e);
            }
            finally {
            }
    },
    async saveActiveAccount({commit}, payload) {
            try{
                commit('LOADING', true);
                await axios.put('admin/customer/'+payload.id,{data:payload,op:'active'})
            }
            catch (e) {
                commit('ERROR', e);
            }
            finally {
                commit('LOADING', false);
            }
    },
    async SendCity({commit}, payload) {
    try{
      commit('LOADING', true);
      const city = await axios.post('admin/customer/query/city',payload)
      return city
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },
    async SendCustomerSingUp({commit}, payload) {
    try{
      commit('LOADING', true);
      const signUp = await axios.post('admin/customer/query/date',payload)
      return signUp
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },
    async SendCustomerGrowth({commit}, payload) {
    try{
      commit('LOADING', true);
      const growth = await axios.post('admin/customer/chart/growth',payload)
      return growth
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },
    async deleteCustomer({commit},id) {
      try {
        commit('LOADING_DELETE', true);
        const {data} = await axios.delete('admin/customer/'+id );
        return data;
      } catch (e) {
        throw e;
      } finally {
        commit('LOADING_DELETE', false);
      }
    },
    async unActiveAccountCustomer({commit},payload) {
      try {
        commit('LOADING_UN_ACTIVE_ACCOUNT_CUSTOMER', true);
        await axios.put('admin/customer/'+payload.id , {data:payload,op:"active"});
      } catch (e) {
        throw e;
      } finally {
        commit('LOADING_UN_ACTIVE_ACCOUNT_CUSTOMER', false);
      }
    },
    async sendMessage({commit},payload) {
      try {
        await axios.post('admin/customer/message',payload);
      } catch (e) {
        throw e;
      } finally {

      }
    },

};

const mutations = {
    CUSTOMER_ID(state, payload) {
        state.getDataCustomer = payload;
    },
    SUCCESS_DATA(state, payload) {
        state.successData = payload;
    },
    LOADING(state, payload) {
        state.loading = payload;
    },
    LOADING_UN_ACTIVE_ACCOUNT_CUSTOMER(state, payload) {
        state.loadingUnActiveAccount = payload;
    },
    EDIT_CUSTOMER(state, payload) {
        state.customerById = state.customerById.map(customer => {
            if (customer.id === payload.id) {
                return Object.assign({},customer, payload.data)
            }
            return customer
        })
    },
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
